@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Modern Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-emerald-50 to-teal-50 shadow-xl border-b-4 border-emerald-200 mb-4 overflow-hidden cstmmrgin"
>
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-emerald-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"
    ></div>
  </div>
  <div class="relative flex items-center justify-between px-8 py-2">
    <div class="flex-1">
      <div class="flex items-center gap-3">
        <div
          class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl shadow-lg flex items-center justify-center"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
        </div>
        <div>
          @if (clntDtls && clntDtls.length > 0) {
          <h1
            class="text-xl font-bold bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-600 bg-clip-text text-transparent mb-0"
          >
            <app-common-header [header_name]="header_label"></app-common-header>
          </h1>
          }
          <p class="text-sm text-gray-500 font-medium mb-1">
            Trip Routes & Deviation Analytics
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-3">
      <div class="flex flex-col min-w-0">
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          class="filter-input"
        ></nz-date-picker>
      </div>
      @if (tntLst.length>1) {
      <div class="flex flex-col min-w-0">
        <nz-select
          class="slctBx"
          nzShowSearch
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
          nzPlaceHolder="Select ULB"
          style="min-width: 160px"
        >
          @for (t of tntLst; track t) {
          <nz-option
            [nzValue]="t.tnt_id"
            [nzLabel]="t.tnt_dsply_nm"
          ></nz-option>
          }
        </nz-select>
      </div>
      } @if (tntLst.length==1) {
      <div class="trte-ulb-badge">
        {{ tntLst[0].tnt_nm }}
      </div>
      } @if (ShowClap) {
      <div class="flex flex-col min-w-0">
        <nz-select
          class="slctBx"
          nzShowSearch
          [(ngModel)]="selectedvndr"
          (ngModelChange)="onvndrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
          nzPlaceHolder="Vehicle Vendor"
          style="min-width: 140px"
        >
          @if (!showVndr) {
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          } @for (v of vendorList; track v) {
          <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
          }
        </nz-select>
      </div>
      }
    </div>
  </div>
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-400 via-teal-500 to-emerald-500"
  ></div>
</div>

<div class="mx-auto px-3">
  <!-- Stat Cards Row -->
  @if (rdCnts && rdCnts.length>0) {
  <div class="trte-cards-row">
    <!-- Trips Card -->
    <div class="trte-stat-card trte-card-teal">
      <div class="trte-card-header">
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          ></path>
        </svg>
        <span>Trips</span>
      </div>
      <div class="trte-card-body">
        <div class="trte-card-col" (click)="getsort(null, 'trips')">
          <div class="trte-card-value">
            {{ rdCnts[0].ttl_trps === null ? "0" : rdCnts[0].ttl_trps }}
          </div>
          <div class="trte-card-label">Total</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(1, 'trips')">
          <div class="trte-card-value">
            {{ rdCnts[0].prmry_trps === null ? "0" : rdCnts[0].prmry_trps }}
          </div>
          <div class="trte-card-label">Primary</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(0, 'trips')">
          <div class="trte-card-value">
            {{ rdCnts[0].scndry_trps === null ? "0" : rdCnts[0].scndry_trps }}
          </div>
          <div class="trte-card-label">Secondary</div>
        </div>
      </div>
    </div>
    <!-- Travelled Trips Card -->
    <div class="trte-stat-card trte-card-green">
      <div class="trte-card-header">
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <span>Travelled Trips</span>
      </div>
      <div class="trte-card-body">
        <div class="trte-card-col" (click)="getsort(null, 'trvl')">
          <div class="trte-card-value">
            {{
              rdCnts[0].trvl_ttl_trps === null ? "0" : rdCnts[0].trvl_ttl_trps
            }}
          </div>
          <div class="trte-card-label">Total</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(1, 'trvl')">
          <div class="trte-card-value">
            {{
              rdCnts[0].trvl_prmry_trps === null
                ? "0"
                : rdCnts[0].trvl_prmry_trps
            }}
          </div>
          <div class="trte-card-label">Primary</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(0, 'trvl')">
          <div class="trte-card-value">
            {{
              rdCnts[0].trvl_scndry_trps === null
                ? "0"
                : rdCnts[0].trvl_scndry_trps
            }}
          </div>
          <div class="trte-card-label">Secondary</div>
        </div>
      </div>
    </div>
    <!-- Route Deviated Card -->
    <div class="trte-stat-card trte-card-rose">
      <div class="trte-card-header">
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          ></path>
        </svg>
        <span>Route Deviated</span>
      </div>
      <div class="trte-card-body">
        <div class="trte-card-col" (click)="getsort(null, 'rd')">
          <div class="trte-card-value">
            {{ rdCnts[0].ttl_rd_trps === null ? "0" : rdCnts[0].ttl_rd_trps }}
          </div>
          <div class="trte-card-label">Total</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(1, 'rd')">
          <div class="trte-card-value">
            {{
              rdCnts[0].prmry_rd_trps === null ? "0" : rdCnts[0].prmry_rd_trps
            }}
          </div>
          <div class="trte-card-label">Primary</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(0, 'rd')">
          <div class="trte-card-value">
            {{
              rdCnts[0].scndry_rd_trps === null ? "0" : rdCnts[0].scndry_rd_trps
            }}
          </div>
          <div class="trte-card-label">Secondary</div>
        </div>
      </div>
    </div>
    <!-- Not Travelled Card -->
    <div class="trte-stat-card trte-card-indigo">
      <div class="trte-card-header">
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          ></path>
        </svg>
        <span>Not Travelled</span>
      </div>
      <div class="trte-card-body">
        <div class="trte-card-col" (click)="getsort(null, 'nt')">
          <div class="trte-card-value">
            {{
              rdCnts[0].nt_trvl_ttl_trps === null
                ? "0"
                : rdCnts[0].nt_trvl_ttl_trps
            }}
          </div>
          <div class="trte-card-label">Total</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(1, 'nt')">
          <div class="trte-card-value">
            {{
              rdCnts[0].nt_trvl_prmry_trps === null
                ? "0"
                : rdCnts[0].nt_trvl_prmry_trps
            }}
          </div>
          <div class="trte-card-label">Primary</div>
        </div>
        <div class="trte-card-divider"></div>
        <div class="trte-card-col" (click)="getsort(0, 'nt')">
          <div class="trte-card-value">
            {{
              rdCnts[0].nt_trvl_scndry_trps === null
                ? "0"
                : rdCnts[0].nt_trvl_scndry_trps
            }}
          </div>
          <div class="trte-card-label">Secondary</div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Vehicle Trip List + Map Section -->
  <div class="trte-section-card">
    <div class="trte-section-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-emerald-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
        <h2 class="trte-section-title">Vehicle Trip Routes</h2>
      </div>
      <div class="trte-route-legend">
        <span class="trte-legend-item">
          <span class="trte-legend-dot trte-dot-scheduled"></span>Scheduled
          Route
        </span>
        <span class="trte-legend-item">
          <span class="trte-legend-dot trte-dot-travelled"></span>Travelled
          Route
        </span>
      </div>
    </div>

    <!-- Filters Row -->
    <div class="trte-filters-row">
      <div class="trte-filter-item">
        <label class="trte-filter-label">Search Vehicle</label>
        <nz-input-wrapper>
          <input
            type="text"
            nz-input
            [(ngModel)]="searchText"
            placeholder="Search here"
            [ngModelOptions]="{ standalone: true }"
            class="trte-search-input"
          />
        </nz-input-wrapper>
      </div>
      <div class="trte-filter-item">
        <label class="trte-filter-label">Category</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Category"
          [(ngModel)]="selectedCtgry"
          (ngModelChange)="selectCategory($event)"
        >
          <nz-option nzLabel="All" nzValue="0"></nz-option>
          @for (c of vehCtgrys; track c) {
          <nz-option [nzLabel]="c.asrt_ctgry_nm" [nzValue]="c.asrt_ctgry_id">
          </nz-option>
          }
        </nz-select>
      </div>
      <div class="trte-filter-item">
        <label class="trte-filter-label">Ward</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Ward"
          [(ngModel)]="slctdWrd"
          (ngModelChange)="selectWard($event)"
        >
          <nz-option nzLabel="All" nzValue="0"></nz-option>
          @for (c of wrds; track c) {
          <nz-option [nzLabel]="c.wrd_nm" [nzValue]="c.wrd_id"> </nz-option>
          }
        </nz-select>
      </div>
    </div>

    <!-- Trip List + Map -->
    <div class="trte-content-area">
      @if (!shwNodata) {
      <div class="trte-trip-list">
        @for (c of vehTrpLst | filter:searchText; track c) {
        <div
          class="trte-trip-card"
          [ngClass]="c.isSelected == true ? 'trte-trip-selected' : ''"
        >
          <div class="trte-trip-main" (click)="getTripMap(c, slctdDt)">
            <div class="trte-trip-top">
              <div class="trte-trip-info">
                <span class="trte-veh-name">{{ c.asrt_nm }}</span>
                <span class="trte-veh-meta"
                  >{{ c.asrt_ctgry_nm }}@if (ShowClap) {
                  <span> | {{ c.vndr_nm }}</span>
                  } | {{ c.wrd_nm }}</span
                >
              </div>
              <div class="trte-trip-status">
                @if (c.rd_in) {
                <span class="trte-deviated-badge">Route Deviated</span>
                }
                <span class="trte-trip-num">Trip - {{ c.trp_sqnc_nu }}</span>
                <span class="trte-trip-sts">{{ c.trip_sts }}</span>
              </div>
            </div>
            <div class="trte-trip-route">
              <div class="trte-route-point">
                <span class="trte-route-label">From</span>
                <div class="trte-route-detail">
                  <span class="trte-route-name">{{ c.strt_fnce_nm }}</span>
                  <span class="trte-route-time"
                    >Schedule: {{ c.sch_strt_tm }} | Actual:
                    {{ c.actl_strt_ts }}</span
                  >
                </div>
              </div>
              <div class="trte-route-point">
                <span class="trte-route-label">To</span>
                <div class="trte-route-detail">
                  <span class="trte-route-name">{{ c.end_fnce_nm }}</span>
                  <span class="trte-route-time"
                    >Schedule: {{ c.sch_end_tm }} | Actual:
                    {{ c.actl_end_ts }}</span
                  >
                </div>
              </div>
            </div>
            <div class="trte-trip-arrow">
              <i nz-icon nzType="right" nzTheme="outline"></i>
            </div>
          </div>
          @if (c.shwAddBtn) {
          <div class="trte-trip-actions">
            <button
              nz-button
              nzType="primary"
              class="trte-master-btn"
              (click)="addRoute()"
            >
              Set as Master Route
            </button>
          </div>
          }
        </div>
        }
      </div>
      } @if (shwNodata) {
      <div class="trte-trip-list trte-no-data">
        <div class="trte-no-data-content">
          <svg
            class="w-12 h-12 text-gray-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
          <p>No Trips Found for Selected Option(s)</p>
        </div>
      </div>
      }
      <div class="trte-map-area">
        <div id="routeDevtmap"></div>
      </div>
    </div>
  </div>

  <nz-modal
    [(nzVisible)]="isVisible"
    (nzOnCancel)="handleCancel()"
    nzWidth="1000"
  >
    <ng-container *nzModalContent>
      <div
        [ngClass]="{
          'map-no-sidebar col-md-8': map_stng.show_build_sidebar == true,
          'map-with-sidebar col-md-12': map_stng.show_build_sidebar != true
        }"
      >
        <div
          leaflet
          style="height: 1200px; width: 140%; margin: 0; padding: 0"
          leafletDraw
          (leafletMapReady)="onMapReady($event)"
          [leafletOptions]="leafletOptions"
          [leafletLayers]="layers"
          [leafletDrawOptions]="drawOptions"
          [leafletDrawLocal]="drawLocal"
          (leafletDrawCreated)="onDrawCreated($event)"
          (leafletDrawStart)="onDrawStart($event)"
          (leafletDrawEditStart)="onDrawStart($event)"
          (leafletDrawEditStop)="onDrawStart($event)"
          (leafletDrawDeleteStart)="onDrawStart($event)"
          (leafletDrawDeleteStop)="onDrawStart($event)"
        >
          <div [leafletLayer]="drawnItems"></div>
          @for (m of markers; track m) {
          <div [leafletLayer]="m"></div>
          }
        </div>
      </div>
    </ng-container>
  </nz-modal>
</div>
